/**
 * PasteCopyBlocker (Sprint 6 B5).
 *
 * Block:
 *   - `paste`  → severity LOW
 *   - `copy`   → severity LOW
 *   - `cut`    → severity LOW (same family)
 *
 * NOT block:
 *   - Context menu (right-click) — em không block UX bình thường vì user có thể
 *     muốn dùng dev tools / inspect element legit (ví dụ debug audio bị tắt).
 *     Devtools open detection có riêng (defer Sprint 7+).
 *
 * Behavior: `preventDefault()` + log violation. Toast không hiện vì có thể spam
 * khi user paste lập đi lập lại (already throttled qua queue flush 5s).
 */

import { useEffect } from "react";

interface Props {
  onViolation: (event: {
    type: "paste_attempt" | "copy_attempt";
    severity: "low";
    detail?: Record<string, unknown>;
  }) => void;
}

export function PasteCopyBlocker({ onViolation }: Props) {
  useEffect(() => {
    const handlePaste = (e: ClipboardEvent) => {
      e.preventDefault();
      onViolation({
        type: "paste_attempt",
        severity: "low",
        detail: { target: (e.target as HTMLElement)?.tagName ?? "unknown" },
      });
    };
    const handleCopy = (e: ClipboardEvent) => {
      e.preventDefault();
      onViolation({
        type: "copy_attempt",
        severity: "low",
        detail: { target: (e.target as HTMLElement)?.tagName ?? "unknown" },
      });
    };

    document.addEventListener("paste", handlePaste);
    document.addEventListener("copy", handleCopy);
    document.addEventListener("cut", handleCopy);
    return () => {
      document.removeEventListener("paste", handlePaste);
      document.removeEventListener("copy", handleCopy);
      document.removeEventListener("cut", handleCopy);
    };
  }, [onViolation]);

  return null;
}
